import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { crearUsuario, ValidarUsuario } from "../../../store/admin/thunkAdmins";

const ModalCrearAdmins = ({ open, handleClose, functions }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name_admin: "",
        email_admin: "",
        phone_admin: "0000",
        cedula_admin: "0000",
        role: "Usuario",
        puesto: "Ventas",
        area: "Mercadeo y ventas",
        firma: "--",
    });

    const [errors, setErrors] = useState({
        name_admin: false,
        email_admin: false,
        phone_admin: false,
        cedula_admin: false,
        role: false,
        puesto: false,
        area: false,
        firma: false,
    });

    const [emailExists, setEmailExists] = useState(false);

    // Manejar cambios en los inputs
    const handleInputChange = async (e) => {
        const { name, value } = e.target;

        // Actualizar el valor del campo
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // Validar si el campo está vacío y actualizar el estado de errores
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: value.trim() === "",
        }));

        // Validar el correo si el campo es "email_admin"
        if (name === "email_admin") {
            await validarEmail(value);
        }
    };

    // Función para validar el correo
    const validarEmail = async (email) => {
        if (email.trim() === "") {
            setEmailExists(false);
            return;
        }

        try {
            const exists = await dispatch(ValidarUsuario(email));
            setEmailExists(exists["0"].count === 1);
        } catch (error) {
            console.error("Error al validar el correo:", error);
        }
    };

    // Validar todos los campos al enviar el formulario
    const validateForm = () => {
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            newErrors[key] = formData[key].trim() === "";
        });
        setErrors(newErrors);
        return !Object.values(newErrors).includes(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar formulario
        if (!validateForm()) {
            console.error("Hay campos vacíos");
            return;
        }


        // Verificar si el correo ya existe
        if (emailExists) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "El correo electrónico ya está en uso. Por favor, utiliza otro correo.",
                confirmButtonText: "Aceptar",
            });
            return;
        } else {
            Swal.fire({
                icon: "success",
                title: "Disponible",
                text: "El correo electrónico está disponible para crear una cuenta.",
                confirmButtonText: "Aceptar",
            });
        }

        handleClose();

        // Confirmar creación de usuario
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Estás a punto de crear un nuevo usuario.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, crear usuario",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            // Mostrar preloader
            Swal.fire({
                title: "Creando Usuario",
                text: "Por favor espere...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            try {
                // Esperar a la creación del cliente
                await dispatch(crearUsuario(formData));

                // Mostrar mensaje de éxito automáticamente
                Swal.fire({
                    icon: "success",
                    title: "Usuario creado",
                    text: "El usuario ha sido creado exitosamente.",
                    showConfirmButton: false,
                    timer: 3000,
                });

                // Ejecutar la función después de 3 segundos
                setTimeout(() => {
                    setFormData(() => ({
                        name_admin: "",
                        email_admin: "",
                        phone_admin: "0000",
                        cedula_admin: "0000",
                        role: "Usuario",
                        puesto: "Ventas",
                        area: "Mercadeo y ventas",
                        firma: "--",
                    }));
                    functions();
                }, 3000);
            } catch (error) {
                console.log(error)
                // Manejar error en la creación del usuario
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Hubo un problema al crear el usuario. Por favor, inténtelo de nuevo.",
                    confirmButtonText: "Aceptar",
                });
            }
        }
    };

    // Obtener la clase del input
    const getInputClass = (fieldName) => {
        return errors[fieldName] ? "form-control is-invalid" : "form-control";
    };

    return (
        <Modal open={open} onClose={handleClose} className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog" style={{ maxWidth: "60%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <h5>Crear nuevo usuario administrador</h5>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label>Nombre</label>
                                        <input type="text" name="name_admin" className={getInputClass("name_admin")} value={formData.name_admin} onChange={handleInputChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label>Email</label>
                                        <input type="email" name="email_admin" className={getInputClass("email_admin")} value={formData.email_admin} onChange={handleInputChange} />
                                        {emailExists && <div className="text-danger">Este correo ya existe.</div>}
                                    </div>

                                    <div className="mb-3">
                                        <label>Teléfono</label>
                                        <input type="text" name="phone_admin" className={getInputClass("phone_admin")} value={formData.phone_admin} onChange={handleInputChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label>Cédula</label>
                                        <input type="text" name="cedula_admin" className={getInputClass("cedula_admin")} value={formData.cedula_admin} onChange={handleInputChange} />
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label>Puesto</label>
                                        <input type="text" name="puesto" className={getInputClass("puesto")} value={formData.puesto} onChange={handleInputChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label>Área</label>
                                        <input type="text" name="area" className={getInputClass("area")} value={formData.area} onChange={handleInputChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label>Firma</label>
                                        <input type="text" name="firma" className={getInputClass("firma")} value={formData.firma} onChange={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <button type="submit" className="btn btn-dark" disabled={emailExists}>
                                Crear usuario
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalCrearAdmins;
